import React, { Component } from 'react';
import { Card, CardBody, CardTitle, Col, Row } from 'reactstrap';
import fondo from "../imgs/KLBackground.png";
import TablaPantalla from "../components/TablaPantalla";
//import VideoPlayerKL from "../components/VideoPantalla"
import VideoPlayerKL from "../components/YouTubeVideoXD"
import '../css/styleHome.css';
import "../../node_modules/video-react/dist/video-react.css";

class PantallaTurno extends Component {

    componentWillMount() {
        const { handle } = this.props.match.params;
        var regexNumber = /^[0-9]+$/;
        if (!handle.match(regexNumber)) {
            this.setState({
                idCola: 99999,
            })
            this.props.history.push('/')
        } else {
            this.setState({
                idCola: handle,
            })
            document.title = "DigiturnoKL - Turnos área " + handle
        }
    }

    render() {
        return (
            <div>
                <div id="home">
                    <div className="bg-img" style={{ backgroundImage: "url(" + fondo + ")" }}>
                    </div>
                    <div className="home-wrapper">
                        <Row>
                            <Col xs="12">
                                <div className="home-content">
                                    <Row>
                                        <Col xs="12">
                                            <Row>
                                                <Col xs="4">
                                                    <TablaPantalla idArea={this.state.idCola}></TablaPantalla>
                                                </Col>
                                                <Col xs="8">
                                                    <Col xs="12">
                                                        <Row>
                                                            <VideoPlayerKL></VideoPlayerKL>
                                                        </Row>
                                                    </Col>
                                                    <Col xs="12">
                                                        <br />
                                                        <Row>
                                                            <Col sm="12">
                                                                <Card body style={{ height: "100%" }}>
                                                                    <CardTitle>¡Búscanos en tus redes sociales favoritas!</CardTitle>
                                                                    <CardBody>
                                                                        <Row>
                                                                            <Col xs="6">
                                                                                <center>
                                                                                    <p><b>Twitter: @UKonradLorenz</b></p>
                                                                                    <p><b>Facebook: @U.KONRADLORENZ</b></p>
                                                                                </center>
                                                                            </Col>
                                                                            <Col xs="6">
                                                                                <center>
                                                                                    <p><b>Instagram: @UKonradLorenz</b></p>
                                                                                    <p><b>YouTube: Konrad Lorenz Fundación Universitaria</b></p>
                                                                                </center>                                                                        </Col>
                                                                        </Row>
                                                                        <Row>
                                                                            <Col xs="12">
                                                                                <center>
                                                                                    <p><b>Línea de atención al usuario: (+571) 347 2311</b></p>
                                                                                </center>
                                                                            </Col>
                                                                        </Row>
                                                                    </CardBody>
                                                                </Card>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>

                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default PantallaTurno;
